export default __webpack_public_path__ + "bb0b65107a8fdabdd17ecd5931b537ad.svg";